// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"5":"8164961fd4deffc6","496":"83edc8afc0370428","742":"28e90e4387a85f1e"}[chunkId] + ".js";
};